import classNames from 'classnames';
import React from 'react';
import styles from './QuoteContent.module.scss';

export interface QuoteContentProps {
  quote: string;
  authorAvatarUrl?: string;
  author: string;
  className?: string;
}

export const QuoteContent: React.FC<QuoteContentProps> = ({
  quote,
  authorAvatarUrl,
  author,
  className,
}) => {
  const styleClassNames = classNames(styles.quote_container, className);

  return (
    <div className={styleClassNames}>
      <span className={styles.quote_mark}>“</span>
      <q className={styles.quote_text}>{quote}</q>
      <div className={styles.attribution_container}>
        {authorAvatarUrl && (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            className={styles.author_avatar}
            src={authorAvatarUrl}
            alt={author}
            title={author}
            loading="lazy"
            decoding="async"
          />
        )}
        <cite className={styles.author_name}>{author}</cite>
      </div>
    </div>
  );
};
